// import * as utils from '@/utils/utils';

import services from '../services/system.js'
import { Message } from 'antd'
import { exportFiles } from '@/utils/utils'
const {
  getAssoList,
  changeRoleStatus,
  organizationList,
  getUserInfo,
  getPrivileges,
  assoUserUpdate,

  getMemberList,
  getProvince,
  getQueryList,
  exportMembers,
  fieldsMapping,
  memberUpdateBatch,
  getMemberPaymentList,
  getAssociateMem,
  cleanAssociateMem,
  getFilterTypeList,
} = services

const namespace = 'system'

export default {
  namespace,
  state: {
    // ========= 协会人员角色 start =============
    // 人员角色数据
    roleTableData: [],
    // 角色 设置弹窗
    setUpVisible: false,
    // 组织list
    organizationList: [],
    // 设置用户 详情
    userInfoData: {},
    // 权限列表
    privileges: [],
    // ========= 协会人员角色 end =============

    // ========= 会员数据 start =============
    userData: [
      {
        key: '1',
        id: '003532',
        companyName: '北京城建',
        style: '理事',
        zizhi: '特级',
        xiehui: '秘书处',
        isFee: '是',
        date: '2020.03.01 15:00',
      },
      {
        key: '2',
        id: '003532',
        companyName: '北京城建',
        style: '理事',
        zizhi: '特级',
        xiehui: '秘书处',
        isFee: '是',
        date: '2020.03.01 15:00',
      },
    ],
    provinceList: [],
    enterpriseType: [],
    memberType: [],
    memberTypeList: [], // 会员类型
    enterpriseTypeList: [], // 企业类型
    provinceNameValues: [], // 所在地列表
    // ========= 会员数据 end =============
    // 准会员列表
    associateList: [],
    loading: true,
    paymentVisible: false,
    paymentRecordData: {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: [],
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // ================================= 协会人员角色 start ========================================
    // 获取协会人员列表
    *getAssoList({ payload, callback }, { call, put }) {
      const res = yield call(getAssoList, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            roleTableData: res.data.list,
          },
        })
        !!callback && callback(res)
      }
    },
    // 改变协会人员状态
    *changeRoleStatus({ payload, callback }, { call, put }) {
      const res = yield call(changeRoleStatus, { ...payload })
      if (res && res.success) {
        let msg = payload && payload.status == 'NORMAL' ? '恢复成功' : '冻结成功'
        Message.success(msg)
        !!callback && callback()
      }
    },
    // 获取组织列表
    *getOrganizationList({ payload, callback }, { call, put }) {
      const res = yield call(organizationList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            organizationList: res.data,
          },
        })
      }
    },
    // 获取协会人员 信息详情
    *getUserInfo({ payload, callback }, { call, put }) {
      const res = yield call(getUserInfo, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            userInfoData: res.data,
          },
        })
        !!callback && callback(res)
      }
    },
    // 获取权限列表
    *getPrivileges({ payload, callback }, { call, put }) {
      const res = yield call(getPrivileges, { ...payload })
      if (res && res.success) {
        // Message.success('')
        let privileges = []
        res.data &&
          res.data.map((item) => {
            let arrItem = { label: item.name, value: item.id }
            privileges.push(arrItem)
          })
        yield put({
          type: 'updateState',
          payload: {
            privileges: privileges,
          },
        })
        !!callback && callback(res)
      }
    },
    // 修改
    *assoUserUpdate({ payload, callback }, { call, put }) {
      const res = yield call(assoUserUpdate, { ...payload })
      if (res && res.success) {
        Message.success('更新成功')
        !!callback && callback(res)
      }
    },
    // ================================= 协会人员角色 end ========================================

    // ================================= 会员数据 start ========================================

    *getMemberList({ payload, callback }, { call, put }) {
      const res = yield call(getMemberList, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            userData: res.data.list,
          },
        })
        !!callback && callback(res)
      }
    },

    *getProvince({ payload, callback }, { call, put }) {
      const res = yield call(getProvince, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            provinceList: res.data.regionlist,
          },
        })
        !!callback && callback(res)
      }
    },

    *getQueryList({ payload, callback }, { call, put }) {
      const res = yield call(getQueryList, { busiType: 'enterpriseType' })
      const res2 = yield call(getQueryList, { busiType: 'memberType' })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            enterpriseType: res.data,
          },
        })
      }
      if (res2 && res2.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            memberType: res2.data,
          },
        })
      }
      !!callback && callback(res)
    },

    *exportMembers({ payload, callback }, { call, put }) {
      const res = yield call(exportMembers, { ...payload })
      !!callback && callback(res)
      exportFiles(res, '会员信息导出.xlsx')
    },

    *fieldsMapping({ payload, callback }, { call, put }) {
      const res = yield call(fieldsMapping, { ...payload })
      !!callback && callback(res)
    },

    *memberUpdateBatch({ payload, callback }, { call, put }) {
      const res = yield call(memberUpdateBatch, { ...payload })
      !!callback && callback(res)
    },

    // 查询会员缴费记录
    *getMemberPaymentList({ payload, callback }, { call, put }) {
      const res = yield call(getMemberPaymentList, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          loading: true,
          paymentVisible: true,
        },
      })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            paymentRecordData: res.data,
            loading: false,
          },
        })
      }
    },

    // ================================= 会员数据 end ========================================

    // ===== 准会员数据start ===================
    *getAssociateMem({ payload, callback }, { call, put }) {
      const res = yield call(getAssociateMem, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            associateList: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    *cleanAssociateMem({ payload, callback }, { call, put }) {
      const res = yield call(cleanAssociateMem, { ...payload })
      !!callback && callback(res)
    },

    *getFilterTypeList({ payload }, { call, put }) {
      const res = yield call(getFilterTypeList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberTypeList: res.data.assoOrgNameValues,
            enterpriseTypeList: res.data.businessScopes,
            provinceNameValues: res.data.enterpriseTypes,
          },
        })
      }
    },

    // ======准会员数据end ======================
  },
  // 订阅事件
  subscriptions: {},
}
